import axios from "@/axios/http";
import qs from "qs";

const accredit = {
  //录入-全局统计走势图-根据时间用户名
  entryStatus(params) {
    return axios.get("/entryTask/statistic/entryStatus?" + qs.stringify(params, { indices: false }));
  },
  //录入-全局统计-导出报表
  exportData(params) {
    return axios.get("/entryTask/statistic/exportData?" + qs.stringify(params, { indices: false }), { responseType: 'blob' });
  },
  //对比-全局统计走势图-根据时间用户名
  compareStatus(params) {
    return axios.get("/compareTask/statistic/compareStatus?" + qs.stringify(params, { indices: false }));
  },
  //对比-全局统计-导出报表
  compareExe(params) {
    return axios.get("/compareTask/statistic/exportData?" + qs.stringify(params, { indices: false }), { responseType: 'blob' });
  },
  //统计-查询全部用户
  allUsers() {
    return axios.get("/users/allUsers");
  },
};

export default accredit;



// WEBPACK FOOTER //
// ./src/api/openPortApi.js